"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["children", "className"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container",
  componentId: "sc-1oatits-0"
})(["background:", ";display:flex;flex-direction:column;height:100vh;min-height:100vh;z-index:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.neutral.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.zIndex.immersive;
});

var ImmersiveFlow = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ImmersiveFlow, _React$Component);

  var _super = _createSuper(ImmersiveFlow);

  function ImmersiveFlow() {
    (0, _classCallCheck2.default)(this, ImmersiveFlow);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ImmersiveFlow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
        className: className
      }, props), children);
    }
  }]);
  return ImmersiveFlow;
}(_react.default.Component);

ImmersiveFlow.defaultProps = {};
ImmersiveFlow.propTypes = {
  /** Custom class for Container */
  className: _propTypes.default.string,

  /** Child content rendered in ImmersiveFlow. */
  children: _propTypes.default.node
};
var _default = ImmersiveFlow;
exports.default = _default;
//# sourceMappingURL=Container.js.map